













































import moment from "moment";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import { PatientDetailsViewModel, Notification } from "@/models";
import { NotificationType } from "../../models";
import SettingsChangedMessage from "./SettingsChangedMessage.vue";

export interface GroupedNotifications {
  /**
   * This is needed by v-for as a unique identifier for the object
   */
  key: string;
  date: moment.Moment;
  notifications: Notification[];
}

export const ShowClosedStorageKey = "Messenger_ShowClosedMessages";

@Component({
  components: {
    SettingsChangedMessage
  }
})
export default class PatientMessages extends Vue {
  // Make the notification type enum available to the HTML code
  NotificationType = NotificationType;

  @Prop() readonly patient!: PatientDetailsViewModel;

  // Make the storage a public property so that it can be overwritten in the unit tests
  storage: Storage = localStorage;

  // Use local storage to save the user's show closed selection across the info/message page as well as across
  // different patients
  private showClosed = false;

  get allNotifications(): GroupedNotifications[] {
    const notifications = this.patient?.notifications || [];
    return this.groupNotificationsByDate(notifications);
  }

  get activeNotifications(): GroupedNotifications[] {
    const notifications = this.patient?.notifications || [];
    return this.groupNotificationsByDate(notifications.filter(n => n.isActive));
  }

  get notifications() {
    const notifications = this.showClosed ? this.allNotifications : this.activeNotifications;
    return notifications || [];
  }

  created() {
    // Need to call this here instead of the field initializer so that this.storage can be hooked up
    this.showClosed = this.loadShowClosed();
  }

  loadShowClosed(): boolean {
    return this.storage.getItem(ShowClosedStorageKey) === "true";
  }

  showClosedChanged() {
    this.storage.setItem(ShowClosedStorageKey, this.showClosed ? "true" : "");
  }

  groupNotificationsByDate(notifications: Notification[]): GroupedNotifications[] {
    const results: GroupedNotifications[] = [];

    notifications.forEach(n => {
      const last = results[results.length - 1];
      if (last?.date.isSame(n.dateStartedLocal, "day")) {
        last.notifications.push(n);
      } else {
        const date = moment(n.dateStartedLocal).startOf("day");
        results.push({
          key: date.format("L"),
          date: date,
          notifications: [n]
        });
      }
    });

    return results;
  }
}
